<template>
	<form class="form form--domain form-domain" @submit.prevent.stop="submitForm(fields)">
		<div class="form__loader" v-if="loading || isLoading">
			<loading-spinner />
		</div>

		<div class="form-section">
			<div class="form-row form-row--col-1">
				<text-field class="form__field" label="Domain (no extension)" v-model="fields.domain" :required="true" />
				<select-field class="form__field" label="Status" v-model="fields.status" :options="domainStatus" />
			</div>
		</div>

		<div class="alert alert--fail" v-if="error" v-html="error"></div>

		<div class="form__actions">
			<a-button class="button--primary form__action" type="submit" :disabled="loading || isLoading">
				{{ fields.domainId ? `Update` : `Create` }} Domain
			</a-button>

			<button class="button button--critical form__action" type="button" :disabled="loading || isLoading" @click="remove(fields)" v-if="fields.domainId && fields.status != 'removed'">
				Remove Domain
			</button>
		</div>
	</form>
</template>

<script>
import { get, pick } from 'lodash'

import AButton from '@/components/AButton'
import LoadingSpinner from '@/components/LoadingSpinner'
import SelectField from '@/components/SelectField'
import TextField from '@/components/TextField'
import { DomainStatus } from '@/lib/enums'

export default {
	name: 'FormDomain',
	components: {
		AButton,
		LoadingSpinner,
		SelectField,
		TextField,
	},
	props: {
		loading: Boolean,
		domain: {
			type: Object,
			default: () => ({}),
		},
	},
	data: () => ({
		defaults: {
		},
		error: null,
		fields: {},
		toUpload: null,
		isLoading: false,
		isImageLoading: false,
	}),
	computed: {
		domainStatus() {
			let status = []
			for (let key in DomainStatus) {
				status.push({
					value: key,
					label: DomainStatus[key],
				})
			}

			return status
		},
	},
	methods: {
		submitForm(fields) {
			if (fields.domainId) {
				this.isLoading = true
				this.$store.dispatch('blacklist/update', { domainId: fields.domainId, data: fields })
					.then(() => {
						this.$notice(`Domain updated!`)
					})
					.catch((error) => {
						this.$notice(`ERROR: ${error.message || error}`)
					})
					.finally(() => {
						this.isLoading = false
					})
			} else {
				this.isLoading = true
				this.$store.dispatch('blacklist/create', fields)
					.then(() => {
						this.$notice(`Domain created!`)
					})
					.catch((error) => {
						this.$notice(`ERROR: ${error.message || error}`)
					})
					.finally(() => {
						this.isLoading = false
					})
			}
		},
		remove(fields) {
			if (!fields.domainId) return

			this.$confirm(`Are you sure you want to remove "${fields.domain}"?`, () => {
				this.$store.dispatch('blacklist/remove', fields.domainId ).then(() => {
					this.$notice(`Domain removed!`)
					this.$router.back()
				}).catch(error => {
					this.$notice(`ERROR: ${error.message || error}`)
				})
			})
		},
	},
	watch: {
		domain: {
			immediate: true,
			handler: function (domainProp) {
				this.fields = {
					...this.defaults,
					...this.fields,
					...pick(domainProp, ['domainId', 'domain', 'createdBy', 'createdByName', 'dateCreated', 'dateModified', 'modifiedBy', 'modifiedByName','status']),
				}
			},
		},
	},
}
</script>

<style scoped lang="scss">
</style>
